// extracted by mini-css-extract-plugin
export default {"container":"Service_container__S1BA2","box_head":"Service_box_head__BygXQ","text_head":"Service_text_head__qL81H","image":"Service_image__kXaXk"};